import Request from './base/Request';

class ConfirmationRequest extends Request {
    constructor(APIURL, header, body) {
        super(APIURL);

        this.options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...header
            },
            body: JSON.stringify(body)
        };
        this.request = this.request.bind(this);
    }
}

export default ConfirmationRequest;
